import { SelectLang as UmiSelectLang } from '@umijs/max';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Company: React.FC<{ children: React.ReactNode }> = (props) => {
  return (
    <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.9)',height: '100%',lineHeight:'100%'}}>
      {props.children}
    </div>
  );
};

export const CurrentTimezone: React.FC = () => {
  const now = new Date();
  const dateString = new Intl.DateTimeFormat("en-CA", {
    timeZone: "UTC",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
  const weekday = now.toLocaleDateString("en-US", {
    timeZone: "UTC",
    weekday: "long",
  });
  // 拼接完整格式
  const formattedTime = `${dateString} ${weekday} (UTC +0)`;
  return (
    <div
      style={{
        fontSize: "14px",
        color: "rgba(0, 0, 0, 0.9)",
        height: "100%",
        lineHeight: "100%",
        marginLeft: '4vw',
      }}
    >
      {/* 获取 0 时区对应的年月日 */}
      <span>{formattedTime}</span>
    </div>
  );
};
